
export default {
  name: 'InfoRefermable',
  props: {
    titre: {
      type: String,
      required: true
    },
    couleur: {
      type: String,
      default: 'bleu-marine'
    },
    grandeurTitre: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      estOuvert: false
    }
  },
  computed: {
    couleurPrincipale () {
      return 'texte--' + this.couleur
    },
    blocInfoStyle () {
      const classeBleu = 'fond--marine-leger ' + this.couleurPrincipale
      const classeOrange = 'fond--orange-leger ' + this.couleurPrincipale

      return this.couleur === 'bleu-marine' ? classeBleu : classeOrange
    },
    majChevron () {
      return this.estOuvert ? 'chevron-top' : 'chevron-bottom'
    }
  },
  methods: {
    controlOuverture: function (event) {
      this.estOuvert = !this.estOuvert
    }
  }
}
